<template>
  <div class="ficha-mapa ficha-hidrografia">
    <div class="encabezado">Hidrografía</div>
    <div class="contenedor">
      <div class="col col-doble">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha5/lago-nabor.png"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Lago Nabor Carrillo</p>
          </div>
          <div class="ficha-cuerpo">
            <div class="contenedor">
              <div class="col">
                <p>
                  El modelo de comportamiento hidrogeológico de la
                  <b
                    >zona lacustre de la Cuenca de México se asocia al de un
                    ecosistema dependiente del agua subterránea</b
                  >
                  (Foster et al., 2006). Esta zona se caracteriza por ser una
                  cuenca endorreica; sin embargo, se encuentra abierta en forma
                  artificial hacia el norte.
                </p>
              </div>
              <div class="col">
                <p>
                  En el Cuaternario Superior, al cerrarse la cuenca,
                  <b
                    >las aguas pluviales y fluviales se descargaron en una serie
                    de lagos
                  </b>
                  que se comunicaban entre sí. El Lago de Chalco era el más
                  meridional y hacia al norte se encontraban sucesivamente el
                  Lago de Xochimilco, el gran Lago de Texcoco, el Lago Xaltocan
                  y el de Zumpango en la parte más septentrional (Conagua,
                  2019).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha5/laguna-xalapango.png"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Laguna de Xalapango</p>
          </div>
          <div class="ficha-titulo">
            <h4></h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Desde el punto de vista hidrológico, en la Región Nororiente de la
              Cuenca de México, el
              <b
                >sistema hídrico se encuentra integrado, principalmente, por
                escurrimientos efímeros e intermitentes de carácter
                torrencial</b
              >, con avenidas de corta duración y arroyos secos durante el
              estiaje. El volumen anual de escurrimiento natural es de 1,129.6
              hm³ y se extrae, en el área de estudio, 2,599.4 hm³; de los cuales
              el 79% se concesiona en la Cuenca de México (63.7 hm³) y en la de
              Texcoco (14.7 hm³).
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hidrografia",
};
</script>

<style scoped>
.ficha-mapa .contenedor .col-doble {
  position: relative;
  flex: 2 1;
}
</style>
